import { IOrder, IProduct } from '@orderingstack/ordering-types';

export function isCartEmpty(order: IOrder | undefined) {
  return !order?.editTotal || parseInt(order.editTotal) === 0;
}

export function formatPrice(
  value: string | number,
  currency?: string | null,
  separator = ',',
  decimals = 2
): string {
  const price = Number(value);
  return `${price.toFixed(decimals).replace('.', separator)}${
    currency ? '\u00a0' + currency : '' // adding &nbsp; character
  }`;
}

export function getMediaOrFallback(
  product: IProduct,
  fallbackImg: string,
  name = 'MAIN_IMG'
): string {
  if (!product.details?.media) return fallbackImg;
  return product.details.media.find((x) => x.name === name)?.url || fallbackImg;
}
